const Background = () => {
    return <div className="bg"></div>
}

export default Background